export default {
    namespaced: true,
    state: {
        appTitle: null,
        operatorManager: null,
        pageTitle: null,
        orderId: null,
        runningTasks: [],
    },
    mutations: {
        setAppTitle(state, title) {
            state.appTitle = title;
        },
        setOperatorManager(state, operatorManager) {
            state.operatorManager = operatorManager;
        },
        setPageTitle(state, title) {
            state.pageTitle = title;
        },
        setOrderId(state, orderId) {
            state.orderId = orderId;
        },
        setRunningTasks(state, tasks) {
            state.runningTasks = tasks.filter((x) => x != null);
        },
        addRunningTask(state, task) {
            state.runningTasks = [...state.runningTasks, task].filter(
                (x) => x != null
            );
        },
    },
    getters: {
        getAppTitle(state) {
            return state.appTitle;
        },
        getOperatorManager(state) {
            return state.operatorManager;
        },
        getPageTitle(state) {
            return state.pageTitle;
        },
        getOrderId(state) {
            return state.orderId;
        },
        getRunningTasks(state) {
            return state.runningTasks.filter((x) => x != null);
        },
    },
};
